import { apiClient } from '../../../../api/axios';
import type { ApiResponse, PaginatedResponse, UserItem, RoleItem } from '../common/types';
import type { GetUsersPayload, CreateUserPayload, UpdateUserPayload, UpdateUserRolePayload } from './types';

export const userService = {
    getAllUsers: async (payload: GetUsersPayload): Promise<ApiResponse<PaginatedResponse<UserItem>>> => {
        const response = await apiClient.post('/Users/GetUsers', payload);
        return response.data;
    },

    getAdminRoles: async (): Promise<ApiResponse<RoleItem[]>> => {
        const response = await apiClient.get('/Roles/GetRoles');
        return response.data;
    },

    getUserCreationRoles: async (): Promise<ApiResponse<RoleItem[]>> => {
        const response = await apiClient.get('/Roles/GetRolesForUserCreation');
        return response.data;
    },

    getUserById: async (userId: string): Promise<ApiResponse<UserItem>> => {
        const response = await apiClient.get(`/Users/GetUserUserById?userId=${userId}`);
        return response.data;
    },

    createUser: async (user: CreateUserPayload): Promise<ApiResponse<boolean>> => {
        const response = await apiClient.post('/Users/CreateUser', user);
        return response.data;
    },

    updateUser: async (user: UpdateUserPayload): Promise<ApiResponse<boolean>> => {
        const response = await apiClient.post('/Users/UpdateUser', user);
        return response.data;
    },

    changeStatus: async (userId: string, status: boolean): Promise<ApiResponse<boolean>> => {
        const response = await apiClient.post(`/Users/ActivateDeativateUserAccount?userId=${userId}&status=${status}`);
        return response.data;
    },

    activateDeactivateUserRole: async (userRoleId: string, status: boolean): Promise<ApiResponse<boolean>> => {
        const response = await apiClient.post(`/Users/ActivateDeactivateUserRole?userRoleId=${userRoleId}&status=${status}`);
        return response.data;
    },

    updateUserRole: async (payload: UpdateUserRolePayload): Promise<ApiResponse<boolean>> => {
        const response = await apiClient.post('/Users/UpdateUserRole', payload);
        return response.data;
    },

    getUsersByRoleId: async (roleId: number): Promise<ApiResponse<UserItem[]>> => {
        const response = await apiClient.get(`/Users/GetUsersByRoleId?roleId=${roleId}`);
        return response.data;
    },

    // Returns the signature image path of the logged-in user (relative to the file base URL).
    getSignature: async (): Promise<ApiResponse<string>> => {
        const response = await apiClient.post('/Users/GetSignature');
        return response.data;
    },
};
